import { useState, useEffect } from "react";
import {
    Button,
    Table,
    Spin,
    Alert,
    message,
    Modal,
    Space
} from "antd";
import {
    FileExcelOutlined,
    ReloadOutlined,
    FilePdfOutlined,
} from "@ant-design/icons";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
    getCeoDistrictSpecialGsReport,
    getAdminBlockReport,
    getAdminGpReport,
    getBlocksummaryforadmin,
    getAdminGpSummaryReport
} from "../api/User";

const DistrictCEOReport = ({ dateFilter }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    /* -------- BLOCK MODAL PAGINATION -------- */
    const [blockCurrentPage, setBlockCurrentPage] = useState(1);
    const [blockPageSize, setBlockPageSize] = useState(10);

    /* -------- GP MODAL PAGINATION -------- */
    const [gpCurrentPage, setGpCurrentPage] = useState(1);
    const [gpPageSize, setGpPageSize] = useState(10);
    /* -------- Block Modal -------- */
    const [blockModalOpen, setBlockModalOpen] = useState(false);
    const [blockModalTitle, setBlockModalTitle] = useState("");
    const [blockData, setBlockData] = useState([]);
    const [blockLoading, setBlockLoading] = useState(false);

    /* -------- GP Modal -------- */
    const [gpModalOpen, setGpModalOpen] = useState(false);
    const [gpModalTitle, setGpModalTitle] = useState("");
    const [gpData, setGpData] = useState([]);
    const [gpLoading, setGpLoading] = useState(false);

    const mainTotals = {
        block_count: data.reduce((s, i) => s + (i.block_count || 0), 0),
        gp_count: data.reduce((s, i) => s + (i.gp_count || 0), 0),
        gram_sabha_held: data.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
        quorum_fulfilled: data.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
        quorum_failed: data.reduce((s, i) => s + (i.quorum_failed || 0), 0),
        never_scheduled_gs: data.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
    };



    const numberSorter = (a, b, key) => {
        const valA = a[key] || 0;
        const valB = b[key] || 0;
        return valA - valB;
    };

    const stringSorter = (a, b, key) => {
        const valA = (a[key] || '').toString().toLowerCase();
        const valB = (b[key] || '').toString().toLowerCase();
        return valA.localeCompare(valB);
    };

    /* ================= MAIN TABLE COLUMNS ================= */
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            key: "district_name",
            width: 160,
            align: "center",

            sorter: (a, b) => stringSorter(a, b, 'district_name'),
            ellipsis: true,
        },
        {
            title: "No. of Blocks",
            dataIndex: "block_count",
            key: "block_count",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'block_count'),
            render: (val, record) => (
                <span
                    onClick={() => openBlockModal(record)}
                    style={clickStyle}
                >
                    {val || 0}
                </span>
            ),
        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "gp_count",
            key: "gp_count",
            width: 160,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gp_count'),
            render: (val, record) => (
                <span
                    onClick={() => openGPFromDistrict(record)}
                    style={clickStyle}
                >
                    {val || 0}
                </span>
            ),
        },
        {
            title: "Gram Sabha Held (including 1st, 2nd & 3rd)",
            dataIndex: "gram_sabha_held",
            key: "gram_sabha_held",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st, 2nd & 3rd)",
            dataIndex: "quorum_fulfilled",
            key: "quorum_fulfilled",
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st, 2nd & 3rd)",
            dataIndex: "quorum_failed",
            key: "quorum_failed",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs",
            key: "never_scheduled_gs",
            width: 170,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),
            render: (val) => <span>{val || 0}</span>,
        },
    ];

    /* ================= BLOCK MODAL COLUMNS (Updated for new API) ================= */
    const blockColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 140,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 180,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "no_of_gram_panchayats",
            width: 150,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'no_of_gram_panchayats'),
            render: (value, record) => (
                <span onClick={() => openGPFromBlock(record)} style={clickStyle}>
                    {value || 0}
                </span>
            ),
        },
        {
            title: "Gram Sabha Held (including 1st, 2nd & 3rd)",
            dataIndex: "total_panchayats_gramsabha_held",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'total_panchayats_gramsabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st, 2nd & 3rd)",
            dataIndex: "quorum_fulfilled_count",
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled_count'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st, 2nd & 3rd)",
            dataIndex: "quorum_failed_count",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed_count'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gramsabha",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gramsabha'),
            render: (val) => <span>{val || 0}</span>,
        },
    ];

    /* ================= GP MODAL COLUMNS ================= */
    const gpColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
            fixed: "left"
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 120,
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
            fixed: "left"
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 140,
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
            fixed: "left"
        },
        {
            title: "Gram Panchayat Name",
            dataIndex: "gp_name",
            width: 200,
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'gp_name'),
            fixed: "left"
        },
        {
            title: "Gram Sabha Held (including 1st, 2nd & 3rd)",
            dataIndex: "gram_sabha_held",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st, 2nd & 3rd)",
            dataIndex: "quorum_fulfilled",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st, 2nd & 3rd)",
            dataIndex: "quorum_failed",
            width: 110,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs",
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),
            render: (val) => <span>{val || 0}</span>,
        },
    ];

    useEffect(() => {
        fetchReportData(dateFilter);
    }, [dateFilter]);

    const fetchReportData = async (currentDateFilter) => {
        try {
            setLoading(true);
            setError(null);

            const token = sessionStorage.getItem("token");

            // Call the API
            const res = await getCeoDistrictSpecialGsReport(token, currentDateFilter);

            console.log("API Response:", res);

            // The data array is in res.data
            const reportData = res?.data || [];

            console.log("Report Data:", reportData);

            const formatted = reportData.map((item, index) => ({
                ...item,
                key: item.district_code || index,
                sr_no: index + 1,
                district_code: item.district_code,
            }));

            setData(formatted);
            message.success(`Loaded ${formatted.length} records`);

        } catch (err) {
            console.error("Fetch Error:", err);

            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError("Failed to fetch report data");
            }

            message.error("Failed to fetch report data");
        } finally {
            setLoading(false);
        }
    };

    /* ================= DRILL FUNCTIONS ================= */
    const openBlockModal = async (district) => {
        console.log('Opening block modal for district:', district.district_name);
        setBlockModalTitle(`Block-wise Report : ${district.district_name}`);
        setBlockModalOpen(true);
        setBlockData([]);
        setBlockLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setBlockLoading(false);
                return;
            }

            // Use the new API: getBlocksummaryforadmin
            console.log('Fetching block summary for district:', district.district_code);
            const result = await getBlocksummaryforadmin(token, district.district_code);

            console.log("Block summary result:", result);

            if (result.success) {
                const blockFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: `${item.district_code}_${item.block_code}` || index + 1,
                    sr_no: index + 1,
                    district_name: item.district_name || district.district_name,
                    block_name: item.block_name,
                    // Note: The new API returns different field names:
                    // no_of_gram_panchayats (instead of gp_count)
                    // total_panchayats_gramsabha_held (instead of gram_sabha_held)
                    // quorum_fulfilled_count (instead of quorum_fulfilled)
                    // quorum_failed_count (instead of quorum_failed)
                    // never_scheduled_gramsabha (instead of never_scheduled_gs)
                    block_code: item.block_code,
                }));

                console.log("Formatted block data:", blockFormatted);
                setBlockData(blockFormatted);
                message.success(`Loaded ${blockFormatted.length} blocks`);
            } else {
                message.error(result.message || 'Failed to fetch block data');
            }
        } catch (err) {
            console.error('Error fetching block data:', err);
            message.error(err.message || 'Failed to fetch block data');
        } finally {
            setBlockLoading(false);
        }
    };

    const openGPFromDistrict = async (district) => {
        console.log('Opening GP modal for district:', district.district_name);
        setGpModalTitle(`Gram Panchayat-wise Report : ${district.district_name}`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            // नया API फंक्शन इस्तेमाल करें (सिर्फ district_code पास करें)
            const result = await getAdminGpSummaryReport(token, district.district_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_name: item.panchayat_name || item.gp_name,
                    gram_sabha_held: item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gramsabha || 0,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${district.district_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data');
        } finally {
            setGpLoading(false);
        }
    };

    const openGPFromBlock = async (block) => {
        setBlockModalOpen(false);
        console.log('Opening GP modal for block:', block.block_name);
        setGpModalTitle(`Gram Panchayat-wise Report : ${block.block_name} (${block.district_name})`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            // नया API फंक्शन इस्तेमाल करें (district_code + block_code दोनों पास करें)
            const result = await getAdminGpSummaryReport(token, block.district_code, block.block_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_name: item.panchayat_name || item.gp_name,
                    gram_sabha_held: item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gramsabha || 0,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${block.block_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data');
        } finally {
            setGpLoading(false);
        }
    };

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    /* ================= EXPORT FUNCTIONS (Updated for new API) ================= */
    const handleExportPDF = () => {
        if (!data.length) return message.warning("No data to export");

        try {
            const doc = new jsPDF("landscape");

            // Title
            doc.setFontSize(18);
            doc.setTextColor(40, 40, 40);
            doc.text("District CEO Special Gram Sabha Report", 105, 20, { align: 'center' });

            // Table data prepare
            const tableColumn = columns.map(col => col.title);

            // Main data rows
            const tableRows = data.map(row =>
                columns.map(col => {
                    const val = row[col.dataIndex];
                    if (val === null || val === undefined) return '';
                    return String(val);
                })
            );

            // 👉 ADD GRAND TOTAL ROW
            const grandTotalRow = [
                '', // Sr. No.
                'GRAND TOTAL', // District Name
                String(mainTotals.block_count), // No. of Blocks
                String(mainTotals.gp_count), // No. of Gram Panchayats
                String(mainTotals.gram_sabha_held), // Gram Sabha Held
                String(mainTotals.quorum_fulfilled), // Quorum Fulfilled
                String(mainTotals.quorum_failed), // Quorum Failed
                String(mainTotals.never_scheduled_gs), // Never Scheduled Gram Sabha
            ];

            // Add grand total row to table rows
            tableRows.push(grandTotalRow);

            // Create table using autoTable function
            autoTable(doc, {
                head: [tableColumn],
                body: tableRows,
                startY: 30,
                theme: 'grid',
                headStyles: {
                    fillColor: [22, 119, 255],
                    textColor: 255,
                    fontStyle: 'bold'
                },
                styles: {
                    fontSize: 9,
                    cellPadding: 2,
                    overflow: 'linebreak'
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245]
                },
                margin: { top: 30 },
                // 👉 Style for grand total row
                didParseCell: function (data) {
                    if (data.row.index === tableRows.length - 1) {
                        data.cell.styles.fillColor = [240, 249, 255]; // Light blue background
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.textColor = [0, 0, 0];
                        // Center align the GRAND TOTAL text
                        if (data.column.index === 1) {
                            data.cell.styles.halign = 'center';
                        }
                    }
                },
                // 👉 Add footer with generation date
                foot: [['', '', '', '', '', '', '', '']],
                footStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [100, 100, 100],
                    fontSize: 8,
                    halign: 'right'
                },
            });

            // Add generation timestamp at the bottom
            const today = new Date();
            const dateStr = today.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });

            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.text(`Generated on: ${dateStr}`, 280, doc.lastAutoTable.finalY + 10, { align: 'right' });

            doc.save(`District_CEO_Report_${new Date().toISOString().split('T')[0]}.pdf`);
            message.success("PDF exported successfully");
        } catch (err) {
            console.error("PDF Export Error:", err);
            message.error("Failed to export PDF: " + err.message);
        }
    };

    const handleExportExcel = () => {
        if (!data.length) return message.warning("No data to export");

        try {
            const excelData = data.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "No. of Blocks": row.block_count || 0,
                "No. of Gram Panchayats": row.gp_count || 0,
                "Gram Sabha Held (including 1st, 2nd & 3rd)": row.gram_sabha_held || 0,
                "Quorum Fulfilled (including 1st, 2nd & 3rd)": row.quorum_fulfilled || 0,
                "Quorum Failed (including 1st, 2nd & 3rd)": row.quorum_failed || 0,
                "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,
            }));

            // 👉 ADD GRAND TOTAL ROW
            excelData.push({
                "Sr. No.": "",
                "District Name": "GRAND TOTAL",
                "No. of Blocks": mainTotals.block_count,
                "No. of Gram Panchayats": mainTotals.gp_count,
                "Gram Sabha Held (including 1st, 2nd & 3rd)": mainTotals.gram_sabha_held,
                "Quorum Fulfilled (including 1st, 2nd & 3rd)": mainTotals.quorum_fulfilled,
                "Quorum Failed (including 1st, 2nd & 3rd)": mainTotals.quorum_failed,
                "Never Scheduled Gram Sabha": mainTotals.never_scheduled_gs,
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "District CEO Report");

            const fileName = `District_CEO_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("Excel file exported successfully");
        } catch (err) {
            console.error("Excel Export Error:", err);
            message.error("Failed to export Excel");
        }
    };

    const handleExportBlockExcel = () => {
        if (!blockData.length) return message.warning("No data to export");

        try {
            const excelData = blockData.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "Block Name": row.block_name || "-",
                "No. of Gram Panchayats": row.no_of_gram_panchayats || 0,
                "Gram Sabha Held (including 1st,2nd & 3rd)": row.total_panchayats_gramsabha_held || 0,
                "Quorum Fulfilled (including 1st,2nd & 3rd)": row.quorum_fulfilled_count || 0,
                "Quorum Failed (including 1st,2nd & 3rd)": row.quorum_failed_count || 0,
                "Never Scheduled Gram Sabha": row.never_scheduled_gramsabha || 0,
            }));

            // 👉 ADD GRAND TOTAL ROW - FIXED column names to match exactly
            excelData.push({
                "Sr. No.": "",
                "District Name": "GRAND TOTAL",
                "Block Name": "",
                "No. of Gram Panchayats": blockData.reduce((s, i) => s + (i.no_of_gram_panchayats || 0), 0),
                "Gram Sabha Held (including 1st,2nd & 3rd)": blockData.reduce((s, i) => s + (i.total_panchayats_gramsabha_held || 0), 0),
                "Quorum Fulfilled (including 1st,2nd & 3rd)": blockData.reduce((s, i) => s + (i.quorum_fulfilled_count || 0), 0),
                "Quorum Failed (including 1st,2nd & 3rd)": blockData.reduce((s, i) => s + (i.quorum_failed_count || 0), 0),
                "Never Scheduled Gram Sabha": blockData.reduce((s, i) => s + (i.never_scheduled_gramsabha || 0), 0),
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Block Report");

            const fileName = `Block_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("Block Excel file exported successfully");
        } catch (err) {
            console.error("Block Excel Export Error:", err);
            message.error("Failed to export Block Excel");
        }
    };

    const handleExportGpExcel = () => {
        if (!gpData.length) return message.warning("No data to export");

        try {
            const excelData = gpData.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "Block Name": row.block_name || "-",
                "Gram Panchayat Name": row.gp_name || "-",
                "Gram Sabha Held (including 1st,2nd & 3rd)": row.gram_sabha_held || 0,
                "Quorum Fulfilled (including 1st,2nd & 3rd)": row.quorum_fulfilled || 0,
                "Quorum Failed (including 1st,2nd & 3rd)": row.quorum_failed || 0,
                "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,
            }));

            // 👉 ADD GRAND TOTAL ROW - FIXED column names to match exactly
            excelData.push({
                "Sr. No.": "",
                "District Name": "GRAND TOTAL",
                "Block Name": "",
                "Gram Panchayat Name": "",
                "Gram Sabha Held (including 1st,2nd & 3rd)": gpData.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
                "Quorum Fulfilled (including 1st,2nd & 3rd)": gpData.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
                "Quorum Failed (including 1st,2nd & 3rd)": gpData.reduce((s, i) => s + (i.quorum_failed || 0), 0),
                "Never Scheduled Gram Sabha": gpData.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "GP Report");

            const fileName = `GP_Report_${gpModalTitle.replace(/[:/]/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("GP Excel file exported successfully");
        } catch (err) {
            console.error("GP Excel Export Error:", err);
            message.error("Failed to export GP Excel");
        }
    };

    /* ================= CLICK STYLE ================= */
    const clickStyle = {
        color: "#1677ff",
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 500,
    };

    return (
        <div className="report-container">
            <div style={{
                background: '#fff',
                padding: '24px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                marginBottom: '24px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <div>
                        <h2 style={{
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '4px',
                            color: '#1f1f1f'
                        }}>
                            District Status of Special Gram Sabha (CEO)
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: '#666',
                            margin: 0
                        }}>
                            Total Records: <strong>{data.length}</strong>
                        </p>
                    </div>

                    <Space>
                        <Button
                            icon={<FilePdfOutlined />}
                            onClick={handleExportPDF}
                            disabled={loading || data.length === 0}
                        >
                            Export PDF
                        </Button>
                        <Button
                            type="primary"
                            icon={<FileExcelOutlined />}
                            onClick={handleExportExcel}
                            disabled={loading || data.length === 0}
                        >
                            Export Excel
                        </Button>
                        <Button
                            icon={<ReloadOutlined />}
                            onClick={() => fetchReportData(dateFilter)}
                            disabled={loading}
                        >
                            Refresh
                        </Button>
                    </Space>
                </div>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        style={{ marginBottom: '16px' }}
                    />
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" />
                        <p style={{ marginTop: '10px', color: '#666' }}>Loading district report data...</p>
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="key"
                        bordered
                        size="small"
                        scroll={{ x: 1200, y: 420 }}
                        pagination={{
                            current: currentPage,
                            pageSize,
                            total: data.length,
                            showSizeChanger: true,
                            // showQuickJumper: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                        }}
                        onChange={handleTableChange}
                    />

                )}
                {data.length > 0 && (
                    <div style={{
                        marginTop: 10,
                        padding: "10px 14px",
                        background: "#f0f9ff",
                        borderRadius: 6,
                        border: "1px solid #bae0ff",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 14,
                        fontSize: 13
                    }}>
                        <span><b>Grand Totals:</b></span>

                        <span>Blocks: <strong>{mainTotals.block_count}</strong></span>

                        <span>GPs: <strong>{mainTotals.gp_count}</strong></span>

                        <span>GS Held: <strong>{mainTotals.gram_sabha_held}</strong></span>

                        <span>Quorum Met: <strong>{mainTotals.quorum_fulfilled}</strong></span>

                        <span>Quorum Failed: <strong>{mainTotals.quorum_failed}</strong></span>

                        <span>Never Scheduled: <strong>{mainTotals.never_scheduled_gs}</strong></span>
                    </div>
                )}

            </div>

            {/* ========== BLOCK MODAL ========== */}
            {/* ========== BLOCK MODAL ========== */}
            <Modal
                open={blockModalOpen}
                onCancel={() => setBlockModalOpen(false)}
                width={1200}
                destroyOnClose
                footer={null}
                closable
                style={{ top: 20 }}
                bodyStyle={{
                    padding: '16px 0 0 0',
                    overflow: 'hidden'
                }}
                title={
                    <div style={{ paddingRight: 40 }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f1f1f" }}>
                                {blockModalTitle}
                            </span>

                            <Button
                                type="primary"
                                icon={<FileExcelOutlined />}
                                onClick={handleExportBlockExcel}
                                disabled={blockLoading || blockData.length === 0}
                                style={{ fontWeight: 500 }}
                            >
                                Export Excel
                            </Button>
                        </div>
                    </div>
                }
            >
                {blockLoading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spin size="large" />
                        <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                            Loading block data...
                        </p>
                    </div>
                ) : blockData.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                        <Alert
                            message={<span style={{ fontWeight: 600 }}>No Data Available</span>}
                            description={
                                <span style={{ fontWeight: 500 }}>
                                    No block data found for this district. Please check if the district
                                    has any blocks assigned.
                                </span>
                            }
                            type="info"
                            showIcon
                        />
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(80vh - 110px)',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            paddingRight: '4px'
                        }}>
                            <Table
                                columns={blockColumns}
                                dataSource={blockData}
                                rowKey="key"
                                bordered
                                size="small"
                                scroll={{
                                    x: 900,
                                    y: undefined
                                }}
                                pagination={{
                                    current: blockCurrentPage,
                                    pageSize: blockPageSize,
                                    total: blockData.length,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '50', '100'],
                                    showTotal: (total, range) =>
                                        `${range[0]}-${range[1]} of ${total} blocks`,
                                }}
                                onChange={(pagination) => {
                                    setBlockCurrentPage(pagination.current);
                                    setBlockPageSize(pagination.pageSize);
                                }}
                            />
                        </div>

                        <div
                            style={{
                                marginTop: 10,
                                padding: "10px 14px",
                                background: "#f0f9ff",
                                borderRadius: 6,
                                border: "1px solid #bae0ff",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 14,
                                fontSize: 13,
                                flexShrink: 0
                            }}
                        >
                            <span><b>Grand Totals:</b></span>
                            <span>Blocks: <strong>{blockData.length}</strong></span>

                            <span>Total GPs: <strong>{blockData.reduce((s, i) => s + (i.no_of_gram_panchayats || i.gp_count || 0), 0)}</strong></span>

                            <span>GS Held: <strong>{blockData.reduce((s, i) => s + (i.total_panchayats_gramsabha_held || i.gram_sabha_held || 0), 0)}</strong></span>

                            <span>Quorum Met: <strong>{blockData.reduce((s, i) => s + (i.quorum_fulfilled_count || i.quorum_fulfilled || 0), 0)}</strong></span>

                            <span>Quorum Failed: <strong>{blockData.reduce((s, i) => s + (i.quorum_failed_count || i.quorum_failed || 0), 0)}</strong></span>

                            <span>Never Scheduled: <strong>{blockData.reduce((s, i) => s + (i.never_scheduled_gramsabha || i.never_scheduled_gs || 0), 0)}</strong></span>
                        </div>
                    </div>
                )}
            </Modal>



            <Modal
                open={gpModalOpen}
                onCancel={() => setGpModalOpen(false)}
                width={1200}
                destroyOnClose
                footer={null}
                closable
                style={{ top: 20 }}
                bodyStyle={{
                    padding: '16px 0 0 0',
                    overflow: 'hidden'
                }}
                title={
                    <div style={{ paddingRight: 40 }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f1f1f" }}>
                                {gpModalTitle}
                            </span>

                            <Button
                                type="primary"
                                icon={<FileExcelOutlined />}
                                onClick={handleExportGpExcel}
                                disabled={gpLoading || gpData.length === 0}
                                style={{ fontWeight: 500 }}
                            >
                                Export Excel
                            </Button>
                        </div>
                    </div>
                }
            >
                {gpLoading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spin size="large" />
                        <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                            Loading Gram Panchayat data...
                        </p>
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(80vh - 110px)',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            paddingRight: '4px'
                        }}>
                            <Table
                                columns={gpColumns}
                                dataSource={gpData}
                                rowKey="key"
                                bordered
                                size="small"
                                scroll={{
                                    x: 900,
                                    y: undefined
                                }}
                                pagination={{
                                    current: gpCurrentPage,
                                    pageSize: gpPageSize,
                                    total: gpData.length,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '50', '100'],
                                    showTotal: (total, range) =>
                                        `${range[0]}-${range[1]} of ${total} GPs`,
                                }}
                                onChange={(pagination) => {
                                    setGpCurrentPage(pagination.current);
                                    setGpPageSize(pagination.pageSize);
                                }}
                            />
                        </div>

                        {/* 🔽 TOTAL STRIP BELOW TABLE */}
                        {gpData.length > 0 && (
                            <div
                                style={{
                                    marginTop: 10,
                                    padding: "10px 14px",
                                    background: "#f0f9ff",
                                    borderRadius: 6,
                                    border: "1px solid #bae0ff",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 14,
                                    fontSize: 13,
                                    flexShrink: 0
                                }}
                            >
                                <span><b>Grand Totals:</b></span>
                                <span>Gram Panchayats: <strong> {gpData.length}</strong></span>

                                <span>GS Held: <strong>{gpData.reduce((s, i) => s + (i.gram_sabha_held || 0), 0)}</strong></span>

                                <span>Quorum Met: <strong>{gpData.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0)}</strong></span>

                                <span>Quorum Failed: <strong>{gpData.reduce((s, i) => s + (i.quorum_failed || 0), 0)}</strong></span>

                                <span>Never Scheduled: <strong>{gpData.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0)}</strong></span>
                            </div>
                        )}
                    </div>
                )}
            </Modal>

        </div>
    );
};

export default DistrictCEOReport;